const files = require.context('./', true, /\.js$/i);
const file_keys = files.keys().filter(key=>key!=="./index.js");
export const methods =  {
    ...file_keys.map(key=>files(key).default).reduce((o,n)=>({...o,...n}),{})
}
export default methods;